import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IonButton, IonContent, IonIcon, IonText } from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'mac-not-found',
  standalone: true,
  imports: [IonContent, IonButton, IonIcon, IonText, RouterLink, TranslatePipe],
  template: `
    <ion-content class="ion-padding">
      <div class="not-found-container">
        <ion-icon name="alert-circle-outline" class="not-found-icon"></ion-icon>
        <ion-text color="dark">
          <h1>404</h1>
          <p>{{ 'NOT_FOUND.MESSAGE' | translate }}</p>
        </ion-text>
        <ion-button routerLink="/" expand="block">
          <ion-icon name="home-outline" slot="start"></ion-icon>
          {{ 'NOT_FOUND.GO_HOME' | translate }}
        </ion-button>
      </div>
    </ion-content>
  `,
  styles: `
    .not-found-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
      text-align: center;
      gap: 1rem;
    }

    .not-found-icon {
      font-size: 6rem;
      color: var(--ion-color-medium);
    }

    h1 {
      font-size: 4rem;
      margin: 0;
      font-weight: 700;
    }

    p {
      font-size: 1.2rem;
      color: var(--ion-color-medium);
      margin: 0;
    }
  `,
})
export class NotFoundPage {}
